<template>
  <div class="hr-dashboard-container">
    <div class="left-container" v-if="endLoadingPersonalSetting">
      <component
        v-for="(item, index) in mainComponentList"
        v-bind="item.props"
        :key="index"
        :is="item.component"
      ></component>
    </div>
    <div class="right-container" v-if="endLoadingPersonalSetting">
      <component
        v-for="(item, index) in rightComponentList"
        :key="index"
        :is="componentsMapping[item.key]"
      >
      </component>
      <PersonalizedButtonVue/>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import Jobs from './components/jobContent.vue'
import Channel from './components/channelContent.vue'
import Application from './components/applicationContent.vue'
import TalentPool from './components/talentPoolContent.vue'
import Interview from './components/interviewsContent.vue'
import SystemAlertsContent from './components/systemAlertsContent.vue'
import PersonalizedButtonVue from './components/personalizedButton.vue'
import RecruiterKpi from './components/recruiterKpiContent.vue'
import HrReportWrapper from './components/hrReportWrapper.vue'
import mixin from './components/mixin'
import { HR_REPORT_CONFIG_DATA_TYPE } from '@/constant/common'

export default {
  mixins: [mixin],
  components: {
    Jobs,
    Channel,
    Application,
    TalentPool,
    Interview,
    SystemAlertsContent,
    PersonalizedButtonVue,
    RecruiterKpi
    // hrReportWrapper
  },
  data () {
    return {
      companyListLoader: null,
      companyList: [],
      company: null,
      rootCompany: null,
      pageSetting: {},
      endLoadingPersonalSetting: false,
      componentsMapping: {
        jobs: Jobs,
        channels: Channel,
        applications: Application,
        newAlerts: SystemAlertsContent
      }
    }
  },
  computed: {
    mainComponentList () {
      const mainViewList = this.pageSetting.mainShow || _.filter([...this.totalMainList], item => item.key !== 'recruiterKpi')
      return _.chain(mainViewList).filter(item => {
        if (item.type === HR_REPORT_CONFIG_DATA_TYPE.CHART) {
          return this.hasHrReportPermission
        }
        return true
      }).map(item => {
        const result = {}
        const componentKey = item.type === HR_REPORT_CONFIG_DATA_TYPE.CHART ? item.type : item.key
        item.component = this.componentsMapping[componentKey]
        if (item.type === HR_REPORT_CONFIG_DATA_TYPE.CHART) {
          result.component = HrReportWrapper
          result.props = {
            configDataId: item.key.replace('bi_chart_', ''),
            reportType: HR_REPORT_CONFIG_DATA_TYPE.CHART
          }
        } else {
          result.component = this.componentsMapping[item.key]
        }
        return result
      }).filter('component').value()
    },
    rightComponentList () {
      const rightViewList = this.pageSetting.rightShow || [...this.totalRightList]
      return _.filter(rightViewList, (item) => this.componentsMapping[item.key])
    }
  },
  created () {
    if (this.hasInterviewPermission) {
      this.componentsMapping.interviews = Interview
    }
    if (this.hasTalentPoolPermission) {
      this.componentsMapping.talentPool = TalentPool
    }
    if (this.hasRecruiterKpiPermission) {
      this.componentsMapping.recruiterKpi = RecruiterKpi
    }
    this.initPersonalPage()
  },
  methods: {
    ...mapActions('company', ['getCompanyChildrenTree']),
    ...mapActions('hrDashboard', ['getPersonalizedInfo']),
    flatCompanyChildrenTreeMap (resultList, company, treeMap) {
      addI18nProperty(company, 'i18nName', 'cn_name', 'name')
      resultList.push(company)
      _.forEach(treeMap[company.id], child => {
        this.flatCompanyChildrenTreeMap(resultList, child, treeMap)
      })
    },
    async loadCompanyList () {
      if (!this.companyListLoader) {
        this.companyListLoader = this.getCompanyChildrenTree().then(resp => {
          const currentCompany = resp.self
          const childrenMap = resp.children
          const rootCompany = resp.root
          const companyList = []
          this.flatCompanyChildrenTreeMap(companyList, currentCompany, childrenMap)
          this.companyList = companyList
          this.company = currentCompany
          this.rootCompany = rootCompany
        })
      }
      await this.companyListLoader
      return this.companyList
    },
    async initPersonalPage () {
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getPersonalizedInfo()
        if (resp && resp.config) {
          this.pageSetting = resp.config
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.endLoadingPersonalSetting = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hr-dashboard-container {
  display: flex;
  justify-content: space-between;
  min-width: 1320px;
  padding-bottom: 14px;

  .left-container {
    width: 70%;
    padding-bottom: 20px;
  }

  .right-container {
    width: 28%;
    padding-bottom: 20px;
  }

  ::v-deep .el-loading-mask {
    z-index: 1;
  }
}
</style>
